import Grid from '@mui/material/Grid';
import Show from "../models/Show";
import moment from "moment";
import DateIcon from "./DateIcon";
import DirectionsIcon from "@mui/icons-material/Directions";
import { Chip } from "@mui/material";

interface ScheduledShowRowProps {
  show: Show;
  onRowClick: Function;
}

function renderCancelledChip(isCancelled: boolean) {
  return isCancelled ? <Chip color="error" label="Show Cancelled"  variant="outlined" className="center show-cancelled-chip"/> : null;
}

function renderAddedMoneyChip(addedMoney: number) {
  return addedMoney ? <Chip color="success" label={`${addedMoney} Added Money`}  variant="outlined" className="center show-cancelled-chip"/> : null;
}

function ScheduledShowRow({show, onRowClick}: ScheduledShowRowProps) {
  return (
    <>
      <div className="card-row" onClick={onRowClick(show)} key={show.id}>
        <Grid className="scheduled-show-row" style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <DateIcon day={moment(show.date).date()} />
          </div>
          <div style={{ flex: 10 }}>
            <div>{show.title}</div>
            <div>{(() => {
              if (!show.date) return '';
              const d = new Date(show.date);
              if (!isNaN(d.getTime())) {
                return d.toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
              }
              return show.date;
            })()}</div>
            {!show.isCancelled && (
              <>
                <div>{show.address1}</div>
                <div>{show.cityState}</div>
              </>
            )}
          </div>
        </Grid>
        {renderCancelledChip(show.isCancelled)}
        {renderAddedMoneyChip(show.addedMoney)}
      </div>
    </>
  );
};

export default ScheduledShowRow;